import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { validateREGON } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const OWNER_REGON_NAME = 'owner.regon';

const InputRegon = ({
  name = OWNER_REGON_NAME,
  focused,
  setFocused,
}: {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
}) => {
  const { i18n } = useLingui();
  const { trigger } = useFormContext();

  return (
    <FormField
      name={name}
      rules={{
        validate: (value: string) => validateREGON(value),
      }}
      render={({ field, fieldState }) => {
        const { value, onChange, onBlur, ...restField } = field;
        return (
          <FormItem className="col-span-4 md:col-span-4">
            <FormControl>
              <Input
                value={value}
                label={i18n.t('REGON')}
                error={fieldState.error?.message}
                success={
                  focused !== field.name && !fieldState.error && field.value
                }
                onChange={(e) => {
                  if (!/^[0-9]*$/.test(e.target.value)) return;
                  if (
                    value?.length >= 14 &&
                    e.target.value?.length > value?.length
                  )
                    return;
                  onChange(e);
                  if (fieldState.error) {
                    trigger(field.name);
                  }
                }}
                onBlur={() => {
                  onBlur();
                  setFocused('');
                }}
                onFocus={() => setFocused(field.name)}
                {...restField}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};

export default InputRegon;
